'use client';

import cx from 'classnames';
import { useGetCtaWrapperContent } from '@/vdp/CtaWrapper';
import { useScrollDetection } from '@/vdp/CtaWrapper/hooks/useScrollDetection';

export default function VdpComposerUpperSlot() {
  const { content } = useGetCtaWrapperContent();
  const hasScrolled = useScrollDetection();

  if (!content) return null;

  return (
    <div
      className={cx(
        'overflow-hidden transition-all duration-300 ease-in-out',
        hasScrolled
          ? '-mb-lg max-h-0 translate-y-[-8px] opacity-0'
          : 'max-h-[300px] translate-y-0 opacity-100'
      )}
      data-testid="composer-upper-slot"
    >
      <div className="flex flex-col gap-md">
        <p className="text-text-inverse t-heading-md">{content.title}</p>
        <p className="text-text-inverse t-body-sm">{content.description}</p>
      </div>
    </div>
  );
}
